import React from "react";
import PanelTitle from "./PanelTitle.tsx";

interface TabBoxProps {
    title?: string;
    icon?: React.ReactNode;
    children: React.ReactNode;
    type?: "small" | "medium" | "large" | "full";
    inverted?: boolean;
}

const TabBox = ({
                    title,
                    icon,
                    type = "medium",
                    inverted = false,
                    children
                }: TabBoxProps) => {
    // On mobile every box stacks to full width; from sm+ the requested
    // proportional width applies so several boxes can share a row.
    const width = type === "full"
        ? "w-full basis-full"
        : type === "medium"
            ? "basis-full sm:basis-[calc(50%-1.2em)]"
            : "basis-full sm:basis-[calc(33.3333%-1.2em)]";

    const surface = inverted
        ? "bg-transparent"
        : "bg-an-surface border border-an-border rounded-an-lg shadow-an-xs";

    return (
        <div className={`flex-1 min-w-0 sm:min-w-[360px] ${surface} ${width}`}>
            <div className="p-4 sm:p-6 md:p-8">
                {(!!title || !!icon) && (
                    <div className="flex items-center gap-2 mb-4">
                        {icon}
                        {!!title && <PanelTitle>{title}</PanelTitle>}
                    </div>
                )}
                <div className="space-y-4">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default TabBox;
